<div class="text-justify container-capped py-3">
  <h1 class="h3">کارپیشه؛ موتور جستجوی آگهی‌های استخدام</h1>

  <p>
    ما در کارپیشه از سال ۱۳۹۸ فعالیت خود را در حوزه کاریابی و بازار کار شروع کردیم و در طی این سال‌ها پیوسته در تلاش
    برای بهبود کیفیت خدمات به کارفرماها و کارجویان بودیم. در ابتدای سال ۱۴۰۱ با یک تغییر رویکرد استراتژیک تصمیم گرفتیم
    خدمات و سرویس‌های خود را بر کارجوها متمرکز کنیم.
  </p>
  <p>
    امروز کارپیشه یک موتور جستجوی پیشرفته شغل است که تمام
    آگهی‌های استخدامی منتشر شده در سایت‌های کاریابی و تعداد قابل توجهی از کانال‌های تلگرامی و اینستاگرام را به صورت
    اتوماتیک و هوشمند جمع‌آوری می‌کند و در اختیار کارجوها قرار می‌دهد. 
  </p>
  <p>
    ما باور داریم که با کارپیشه همه کار پیدا می‌کنند و برای رسیدن به این هدف تلاش می‌کنیم.
  </p>
</div>